import { Routes } from '@angular/router';
import { RouterAuthEnum } from 'projects/shared/src/lib/infrastructure/enums/router-link.enum';
import { HeorotRouterEnum } from 'projects/heorot/src/app/infrastructure/enums/router-link.enum';
import { CanActivateUser } from 'projects/shared/src/lib/core/guards/url-allowed.guard';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    canActivate: [CanActivateUser],
    data: {
      // data for canActivateAdmin
      project: ProjectName.Heorot,
    },
  },
  {
    path: HeorotRouterEnum.PlanProgramme,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/programme-planner/programme-planner.component').then(
        (m) => m.ProgrammePlannerComponent
      ),
  },
  {
    path: HeorotRouterEnum.PlanTest,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/test-planner/test-planner.component').then((m) => m.TestPlannerComponent),
  },
  {
    path: HeorotRouterEnum.DeleteTest,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/delete-test/delete-test.component').then((m) => m.DeleteTestComponent),
  },
  {
    path: HeorotRouterEnum.PlanNormTest,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/norm-test-planner/norm-test-planner.component').then((m) => m.NormTestPlannerComponent),
  },
  {
    path: HeorotRouterEnum.PlanningAndResults,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/results/results.component').then((m) => m.ResultsComponent),
  },
  {
    path: HeorotRouterEnum.Settings,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: HeorotRouterEnum.PaperTestResult,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/paper-test-results/paper-test-results.component').then((m) => m.PaperTestResultsComponent),
  },
  {
    path: HeorotRouterEnum.Changelog,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/changelog/changelog.component').then((m) => m.ChangelogComponent),
  },
  {
    path: HeorotRouterEnum.Planning,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/planning-overview/planning-overview.component').then(
        (m) => m.PlanningOverviewComponent
      ),
  },
  {
    path: RouterAuthEnum.Callback,
    redirectTo: '',
  },
  {
    path: RouterAuthEnum.LoggedOut,
    loadComponent: () =>
      import('./pages/auth/loggedout/loggedout.component').then((m) => m.LoggedoutComponent),
  },
  {
    path: RouterAuthEnum.Forbidden,
    loadComponent: () =>
      import('./pages/auth/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
];
